export default "__VITE_ASSET__DxTubfyN__"